export default {
    path: 'artist',
    name: 'artist',
    component: () => import('@/pages/artist/ArtistList'),
    meta: {title: '红人管理'},
    children: [
        {
            path: 'create',
            name: 'artist_create',
            component: () => import('@/pages/artist/CreateEdit'),
            meta: {title: '添加红人'},
        },
        {
            path: ':artist_id/edit',
            name:'artist-edit',
            component: () => import('@/pages/artist/CreateEdit'),
            meta: {title: '编辑红人'},
        },
        {
            path: ':artist_id/intro',
            name: 'artist_intro',
            component: () => import('@/pages/artist/intro/ArtistIntro'),
            // component: () => import('@/pages/artist/intro/index'),
            meta: {title: '红人详情'},
        },
        {
            path: 'compare/list',
            name: 'artist_compare',
            component: () => import('@/pages/artist/compare/ArtistCompareList'),
            meta: {title: '红人对照'},
        },
        {
            path: 'base',
            name: 'artist_base',
            component: () => import('@/pages/artist/base/index'),
            meta: {title: '基础数据'},
        }
    ]
}
